import LabelledDivRow from "components/LabelledDivRow";
import React from "react";

interface Props {
  derTicketService: server.dto.DerTicketServiceDiagnostic
}

const DerTicketServiceRows = ({ derTicketService }: Props) => {
  return <>
    <LabelledDivRow label="Server">
      <div style={{ overflowWrap: "anywhere" }}>
        {derTicketService.url}<br />
      </div>
    </LabelledDivRow>

    <LabelledDivRow label="">
      <div style={{ overflowWrap: "anywhere" }}>
        <a href={`${derTicketService.url}swagger`} target="_blank" rel="noreferrer">Swagger</a>
      </div>
    </LabelledDivRow>
  </>;
};

export default DerTicketServiceRows;